import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import ApplicationLayout from "src/layouts/Application";
import VanillaLayout from "src/layouts/Vanilla";

import BigFlipLogo from "src/assets/images/common/logo-big-flip.png";
import IlusMaintenance from "src/assets/images/maintenance/ilus-maintenance.png";

import NewGeneralAPI from "src/api/new-interfaces/live/general";
import { isAuthenticated } from "src/helpers/auth";
import history from "src/helpers/browser-history";
import privateRoutes from "src/routes/private-routes";

function MaintenancePage() {
  let isMounted = true;
  const { t } = useTranslation("maintenance");
  const signed = isAuthenticated();
  /* Check current status
   *
   * How?
   * Hit any endpoint (eg: operational hours),
   * - if it returns value, then the status is OK (no maintenance)
   * - else, maintenance
   *
   * What if the API is returned error instead of maintenance?
   * > Well, for now it is considered not OK, so still in this page.
   */
  async function checkCurrent() {
    try {
      const response = await NewGeneralAPI.getOperationalHours();
      if (isMounted && response) history.push(privateRoutes.home.path);
    } catch (errors) {}
  }

  useEffect(() => {
    if (!signed) {
      checkCurrent();
    }
  }, [signed]);

  function renderContent() {
    return (
      <div className="u-pt-10 u-text-center">
        <img className="u-my-10" src={BigFlipLogo} alt="Flip for Business Logo" height="41" />
        <h1>{t("title")}</h1>

        <img src={IlusMaintenance} alt="Maintenance" height="300" className="u-mb-5" />
        <p>{t("info")}</p>
      </div>
    );
  }

  return signed ? (
    <ApplicationLayout data-qaid="qa-maintenance-page">{renderContent()}</ApplicationLayout>
  ) : (
    <VanillaLayout data-qaid="qa-maintenance-page">{renderContent()}</VanillaLayout>
  );
}

export default MaintenancePage;
